import { render, staticRenderFns } from "./MaterialSelect.vue?vue&type=template&id=3034bbbf&scoped=true"
import script from "./MaterialSelect.vue?vue&type=script&lang=js"
export * from "./MaterialSelect.vue?vue&type=script&lang=js"
import style0 from "./MaterialSelect.vue?vue&type=style&index=0&id=3034bbbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3034bbbf",
  null
  
)

export default component.exports